import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/Http';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  avdelinger: any;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    //this.http.get('http://localhost:5000/api/Registre').subscribe(data => {
    //  // Read the result field from the JSON response.
    //  this.avdelinger = data;
    //});
  }

}



// WEBPACK FOOTER //
// C:/Users/tormo/Documents/InterNova/Kunder/Mattilsynet/plvmWEB/webapp/src/app/navbar/navbar.component.ts